// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".I9yNZ_uyNznutF4FdpxQ{color:inherit}.I9yNZ_uyNznutF4FdpxQ:hover{opacity:.6}", "",{"version":3,"sources":["webpack://./src/components/externalLink/externalLink.module.scss"],"names":[],"mappings":"AAAA,sBAEE,aAAA,CAEA,4BACE,UAAA","sourcesContent":[".link {\r\n  // text-decoration: none;\r\n  color: inherit;\r\n\r\n  &:hover {\r\n    opacity: 0.6;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": "I9yNZ_uyNznutF4FdpxQ"
};
export default ___CSS_LOADER_EXPORT___;
